{
  "pages": {
    "listTitle": "Khoản thu",
    "recordTitle": "Tạo khoản thu",
    "categoriesTitle": "Danh mục thu",
    "permissionDenied": "Bạn không có quyền xem khoản thu.",
    "categoriesPermissionDenied": "Bạn không có quyền xem danh mục thu.",
    "createPermissionDenied": "Bạn không có quyền ghi nhận khoản thu.",
    "updatePermissionDenied": "Bạn không có quyền sửa khoản thu."
  },
  "fields": {
    "code": "Mã",
    "date": "Ngày",
    "source": "Nguồn",
    "category": "Danh mục",
    "description": "Mô tả",
    "method": "Phương thức",
    "amount": "Số tiền",
    "clinic": "Phòng khám",
    "notes": "Ghi chú",
    "recordedBy": "Người ghi nhận",
    "confirmedBy": "Người xác nhận",
    "cancelledBy": "Người hủy",
    "cancelReason": "Lý do hủy",
    "name": "Tên",
    "sortOrder": "Thứ tự",
    "type": "Loại",
    "status": "Trạng thái",
    "incomeDate": "Ngày thu"
  },
  "placeholders": {
    "category": "Chọn danh mục",
    "categoryName": "Ví dụ: Bán sản phẩm",
    "sortOrder": "Ví dụ: 1",
    "clinic": "Chọn phòng khám",
    "amount": "Nhập số tiền",
    "paymentMethod": "Chọn phương thức",
    "description": "Thu tiền mặt khách lẻ",
    "notes": "Nhập ghi chú",
    "cancelReason": "Nhập lý do hủy phiếu"
  },
  "actions": {
    "recordIncome": "Tạo khoản thu",
    "record": "Xác nhận",
    "recording": "Đang xác nhận...",
    "saveDraft": "Lưu nháp",
    "savingDraft": "Đang lưu nháp...",
    "saving": "Đang lưu...",
    "viewDetails": "Xem chi tiết khoản thu",
    "viewPayment": "Xem thanh toán",
    "edit": "Sửa",
    "delete": "Xóa",
    "cancelSlip": "Hủy phiếu",
    "cancelling": "Đang hủy...",
    "addCategory": "Thêm danh mục",
    "history": "Lịch sử"
  },
  "search": {
    "incomePlaceholder": "Tìm theo mã, mô tả...",
    "categoryPlaceholder": "Tìm danh mục..."
  },
  "filters": {
    "trigger": "Bộ lọc",
    "title": "Lọc khoản thu",
    "clearAll": "Xóa tất cả",
    "apply": "Áp dụng",
    "dateRange": "Khoảng thời gian",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "selectCategory": "Chọn danh mục",
    "selectSource": "Chọn nguồn",
    "selectMethod": "Chọn phương thức",
    "selectClinic": "Chọn phòng khám",
    "selectStatus": "Chọn trạng thái",
    "allCategories": "Tất cả danh mục",
    "allSources": "Tất cả nguồn",
    "allMethods": "Tất cả phương thức",
    "allClinics": "Tất cả phòng khám",
    "allStatuses": "Tất cả trạng thái"
  },
  "sources": {
    "payment": "Thanh toán",
    "paymentSync": "Đồng bộ thanh toán",
    "manual": "Thủ công",
    "walletTopup": "Nạp tiền TK nạp trước"
  },
  "table": {
    "emptyIncomes": "Không tìm thấy khoản thu nào.",
    "emptyCategories": "Chưa có danh mục thu",
    "noCategoryFound": "Không tìm thấy danh mục",
    "createdAt": "Ngày tạo",
    "updatedAt": "Ngày sửa",
    "createdBy": "Người tạo",
    "updatedBy": "Người cập nhật"
  },
  "history": {
    "title": "Lịch sử danh mục",
    "empty": "Chưa có thay đổi nào trên mục này."
  },
  "details": {
    "title": "Chi tiết khoản thu",
    "syncedAlert": "Khoản thu này được đồng bộ từ thanh toán. Sửa hoặc xóa tại mục Thanh toán."
  },
  "statuses": {
    "draft": "Nháp",
    "recorded": "Xác nhận",
    "cancelled": "Hủy phiếu"
  },
  "categoryType": {
    "system": "Hệ thống",
    "custom": "Tùy chỉnh"
  },
  "categoryStatus": {
    "active": "Đang dùng",
    "inactive": "Ngừng dùng"
  },
  "dialogs": {
    "addCategoryTitle": "Thêm danh mục thu",
    "editCategoryTitle": "Sửa danh mục thu",
    "confirmDeleteIncome": "Xóa bản ghi khoản thu này?",
    "cancelTitle": "Hủy phiếu thu",
    "confirmCancel": "Phiếu {{code}} sẽ chuyển sang Hủy phiếu và không còn tính vào tiền. Mã phiếu vẫn giữ."
  },
  "form": {
    "categoryName": "Danh mục thu",
    "amount": "Số tiền",
    "incomeDate": "Ngày thu",
    "paymentMethod": "Phương thức thanh toán",
    "description": "Mô tả",
    "notes": "Ghi chú",
    "editTitle": "Sửa khoản thu",
    "save": "Lưu"
  },
  "validation": {
    "categoryNameRequired": "Vui lòng nhập danh mục thu",
    "categoryNameTooLong": "Danh mục thu không quá {{max}} ký tự",
    "sortOrderInvalid": "Thứ tự phải là số từ 0 đến 999999",
    "selectCategory": "Vui lòng chọn danh mục",
    "selectClinic": "Vui lòng chọn phòng khám",
    "validAmount": "Vui lòng nhập số tiền hợp lệ",
    "incomeDateRequired": "Vui lòng chọn ngày thu",
    "paymentMethodRequired": "Vui lòng chọn phương thức thanh toán"
  },
  "toasts": {
    "loadListFailed": "Không tải được danh sách khoản thu",
    "loadListError": "Lỗi khi tải khoản thu. Vui lòng thử lại.",
    "loadDetailsFailed": "Không tải được chi tiết khoản thu.",
    "loadCategoriesFailed": "Không tải được danh mục thu",
    "categoryCreated": "Đã thêm danh mục thu",
    "categoryUpdated": "Đã cập nhật danh mục thu",
    "categorySaveFailed": "Lưu danh mục thất bại",
    "categoryDeactivated": "Đã ngừng dùng danh mục",
    "categoryDeactivateFailed": "Ngừng dùng danh mục thất bại",
    "incomeRecorded": "Đã ghi nhận khoản thu",
    "draftSaved": "Đã lưu nháp",
    "incomeUpdated": "Đã cập nhật khoản thu",
    "incomeSaveFailed": "Lưu khoản thu thất bại",
    "incomeDeleted": "Đã xóa khoản thu",
    "incomeDeleteFailed": "Xóa khoản thu thất bại",
    "cancelled": "Đã hủy phiếu thu",
    "cancelFailed": "Hủy phiếu thu thất bại"
  },
  "errors": {
    "INCOME_CANCEL_REASON_REQUIRED": "Vui lòng nhập lý do hủy",
    "INCOME_CANCEL_REASON_TOO_LONG": "Lý do hủy quá dài",
    "INCOME_ALREADY_CANCELLED": "Phiếu thu đã được hủy",
    "INCOME_STATUS_INVALID": "Không đổi được trạng thái phiếu thu"
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} / {{count}}",
    "moreThan": "hơn {{to}}"
  }
}
